import React from "react";
import { RiCloseLine } from "react-icons/ri";
import Badge from "UpdatedFeatures/Badge";

const ViewTransferDetailsModal = ({ open, setOpen, selectedTransfer }) => {
  if (!open || !selectedTransfer) return null;

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleDateString("fr-FR");
  };

  const groupedByReceiverPos = selectedTransfer?.transfert_receivers.reduce(
    (acc, item) => {
      if (!acc[item.receiver_pos_id]) {
        acc[item.receiver_pos_id] = {
          receiver_pos_id: item.receiver_pos_id,
          receiver_pos: item.receiver_pos,
          receiver_pos_name: item.receiver_pos_name,
          transfers: [],
        };
      }
      acc[item.receiver_pos_id].transfers.push(item);
      return acc;
    },
    {}
  );

  const result = Object.values(groupedByReceiverPos);

  console.log(result);

  return (
    <div
      className="fixed inset-0 z-50"
      style={{ zIndex: 9991, overflow: "auto" }}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75"
        aria-hidden="true"
        onClick={() => setOpen(false)}
      />

      {/* Modal Content */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div
          className="relative w-full max-w-3xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex justify-between items-center p-6 bg-[#b269ae] border-b border-gray-500/30">
            <h3
              id="modal-title"
              className="text-lg font-medium leading-6 text-white"
            >
              Détails du Transfert
            </h3>
            <button
              type="button"
              className="inline-flex items-center justify-center p-1.5 text-white hover:text-gray-200"
              onClick={() => setOpen(false)}
            >
              <RiCloseLine className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>

          <div className="p-6">
            {/* Transfer Header Information */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <h4 className="text-sm font-medium text-gray-500">
                    Référence
                  </h4>
                  <p className="font-semibold text-lg">
                    {selectedTransfer.reference || `TRF${selectedTransfer.id}`}
                  </p>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-gray-500">Statut</h4>
                  <Badge status={selectedTransfer.status} type="transfer" />
                </div>
                <div>
                  <h4 className="text-sm font-medium text-gray-500">
                    Date de création
                  </h4>
                  <p>{formatDate(selectedTransfer.created_at)}</p>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-gray-500">
                    Point de vente d'origine
                  </h4>
                  <p className="font-medium">
                    {selectedTransfer.sender_pos == null
                      ? selectedTransfer.sender_pos_name || "KD Marché"
                      : selectedTransfer.sender_pos.name}
                  </p>
                </div>
              </div>
            </div>

            {/* Receivers Section */}
            <h4 className="text-md font-semibold text-gray-800 mb-4 pb-2 border-b">
              Destinations et Produits
            </h4>

            {result?.map((receiver, index) => (
              <div key={index} className="mb-6 last:mb-0">
                <div className="bg-gray-50 p-4 rounded-lg mb-4 border">
                  <h5 className="font-medium text-gray-700 mb-2">
                    Destination:{" "}
                    {receiver.receiver_pos_id == null &&
                    receiver.receiver_pos_name == null
                      ? "KD Marché"
                      : receiver?.receiver_pos_name}
                  </h5>

                  <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-300">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase">
                            Produit
                          </th>
                          <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase">
                            Quantité
                          </th>
                          <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase">
                            Statut
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {receiver.transfers?.map((transfer, productIndex) => (
                          <tr key={productIndex} className="hover:bg-gray-50">
                            <td className="py-3 px-4">
                              <div className="flex items-center">
                                <div>
                                  <div className="font-medium text-gray-900">
                                    {transfer?.product_title}
                                  </div>
                                  <div className="text-xs text-gray-500">
                                    ID: {transfer?.id}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="py-3 px-4">
                              {transfer?.received_quantity
                                ? transfer?.received_quantity
                                : transfer?.quantity}
                            </td>
                            <td className="py-3 px-4">
                              <span
                                className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                  transfer?.status === 1 ||
                                  selectedTransfer.status === 1
                                    ? "bg-green-100 text-green-800"
                                    : "bg-yellow-100 text-yellow-800"
                                }`}
                              >
                                {transfer?.status === 1 ||
                                selectedTransfer.status === 1
                                  ? "Validé"
                                  : "En attente"}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ))}

            {/* Footer */}
            <div className="mt-6 flex justify-end">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewTransferDetailsModal;
